import { QUERY_KEY } from 'constants/globalConstants'
import ApiService from 'apiService'
import { useQuery } from 'react-query'

const useNodeDonutDetails = (id, nodeId) => {
    return useQuery(QUERY_KEY.NODE_DONUT_DETAILS, () => ApiService.nodeDonutDetails(id, nodeId), {retry: false})
}

export default useNodeDonutDetails